import actionCreatorFactory from 'typescript-fsa';
import { Brand } from './brands.reducer';
const actionCreator = actionCreatorFactory('Brands');

export const updateBrandEntities = actionCreator<{
  brands: {
    [key: number]: Brand;
  };
  appId: number;
}>('ENTITIES_UPDATE');



// WEBPACK FOOTER //
// ./src/store/Entities/Brands/brands.actions.ts